<template>
    <div class="searchActivity" @click="getActivtyInfo(activity.id)">
        <h2>{{htmlDecode(activity.title)}}</h2>
        <div class="s_content">
            <div class="search_img">
                <img :src="weburl+activity.image" alt="">
            </div>
            <div class="search_word">
                <p>{{activity.brief}}</p>
            </div>
        </div>
        <span>{{$t('nav.activity]')}}</span>
    </div>
</template>
<script>
    export default {
        name: "searchActivity",
        props:['activity'],
        methods:{
            getActivtyInfo(id){
                this.$router.push({
                    path: `/activityDetail/${id}`,
                })
            }
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/search";
    .searchActivity {
        .s_layout;
        .s_content {
            height: 72px;
            width: @width;
            .search_word {
                height: @width;
                p{
                    overflow: hidden;
                    text-overflow:ellipsis;//文本溢出显示省略号
                    display: -webkit-box;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                }

            }

        }
    }

</style>
